import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import LinearScaleIcon from "@mui/icons-material/LinearScale";

export const MAP_MODES = [
  {
    mode: "LINES",
    name: "Lignes",
    icon: <HorizontalRuleIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />,
  },
  {
    mode: "LINES_AND_POINTS",
    name: "Lignes avec points",
    icon: <LinearScaleIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />,
  },
];
